/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag Fragment */
import BaseExhibitorSections from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorSections';
import { Fragment } from 'react';
import { jsx } from 'theme-ui';
import ExhibitorFloorPlan from './ExhibitorFloorPlan';

export * from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorSections';
// export { default } from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorSections';

/**
 * A component to contain all the exhibitor details sections.
 * It can be used to prepend or append some content in shadowed components.
 * @param {object} props
 * @param {object} props.exhibitor The exhibitor.
 * @param {string} props.eventId The event id.
 * @returns
 */
export default function ExhibitorSections({ exhibitor, eventId, ...rest }) {
  return (
    <>
      <ExhibitorFloorPlan data={exhibitor} />
      <BaseExhibitorSections
        exhibitor={exhibitor}
        eventId={eventId}
        {...rest}
      />
    </>
  );
}

ExhibitorSections.fragment = BaseExhibitorSections.fragment;
ExhibitorSections.liveFragment = BaseExhibitorSections.liveFragment;
